var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoodmacLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4783 3.13884C13.6285 3.28837 13.7075 3.48513 13.7075 3.69763C13.7075 3.91013 13.6206 4.10689 13.4783 4.25643L0.909091 16.7703C0.758893 16.9199 0.529644 16.9671 0.332016 16.8884C0.134387 16.8097 0 16.6129 0 16.4004V0.604577C0 0.360596 0.150198 0.140226 0.379447 0.0457812C0.608696 -0.0486632 0.869565 0.00642939 1.04348 0.179578L4.80632 3.92587C5.05929 4.17773 5.47036 4.17773 5.73123 3.92587L9.43874 0.23467C9.74704 -0.0722743 10.253 -0.0722743 10.5613 0.23467L13.4783 3.13884ZM6.53755 13.7874C6.38735 13.6379 6.3083 13.4412 6.3083 13.2287C6.3083 13.0162 6.39526 12.8194 6.53755 12.6699L19.1067 0.155966C19.2569 0.00642939 19.4862 -0.0407928 19.6838 0.0379109C19.8814 0.116615 20.0158 0.313374 20.0158 0.525874V16.3217C20.0158 16.5657 19.8656 16.7861 19.6364 16.8805C19.4071 16.9749 19.1462 16.9199 18.9723 16.7467L15.2095 13.0004C14.9565 12.7486 14.5455 12.7486 14.2846 13.0004L10.5771 16.6916C10.2688 16.9986 9.76285 16.9986 9.45455 16.6916L6.53755 13.7874Z",
    fill: "#0024FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodmacLogo);
export default __webpack_public_path__ + "static/media/woodmac_logo.d2518c366d5df2a4648c08d31845693f.svg";
export { ForwardRef as ReactComponent };